import type { Movie } from "@/mocks/movies";
import MovieCard from "@/components/base/MovieCard";
import SectionHeader from "@/components/base/SectionHeader";

interface MovieGridSectionProps {
  title: string;
  subtitle?: string;
  movies: Movie[];
  moreHref?: string;
}

export default function MovieGridSection({
  title,
  subtitle,
  movies,
  moreHref,
}: MovieGridSectionProps) {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
      <SectionHeader title={title} subtitle={subtitle} moreHref={moreHref} />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-5">
        {movies.map((movie, index) => (
          <MovieCard key={movie.id} movie={movie} index={index} />
        ))}
      </div>
    </section>
  );
}